import React, { Component } from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import styled from "styled-components";
import { Link } from "react-router-dom";

class ModelParayNagarawa extends Component {
  render() {
    return (
      <ProductConsumer>
        {(value) => {
          const {
            RP_openmodel,
            RP_CloseModal,
            RP_ParayNahatu,
            AddProChange,
            RP_from,
            RP_to
          } = value;

          if (!RP_openmodel) {
            return null;
          } else {
            return (
              <ModalContainer>
                <div className="container">
                  <div className="row">
                    <div
                      id="modal"
                      className="col-8 mx-auto col-10 col-lg-7 text-center text-capitalize p-5"
                    >
                      <div className="row">
                        <div className="col-12 mb2">
                          <h3>ڕاپۆرتی پارەی نەگەڕاوە</h3>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-6">
                          <div className="form-group">
                            <label className="text-danger f3 font-weight-bold">
                              هەتاوەکو
                            </label>
                            <br />
                            <input
                              type="date"
                              onChange={AddProChange}
                              name="RP_to"
                              value={RP_to}
                              className="selectpicker btn btn-dark f4"
                            />
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="form-group">
                            <label className="text-danger f3 font-weight-bold">
                              لە
                            </label>
                            <br />
                            <input
                              type="date"
                              onChange={AddProChange}
                              name="RP_from"
                              value={RP_from}
                              className="selectpicker btn btn-dark f4"
                            />
                          </div>
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-6">
                          <Link to="/">
                            <button
                              className="btn btn-success"
                              onClick={() => RP_CloseModal()}
                            >
                              چوونەدەرەوە
                            </button>
                          </Link>
                        </div>
                        <div className="col-6">
                          <Link to="/raporty-paraynadraw">
                            <button
                              className="btn btn-info"
                              onClick={(e) => {
                                RP_ParayNahatu(e);
                              }}
                            >
                              پیشاندان
                            </button>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ModalContainer>
            );
          }
        }}
      </ProductConsumer>
    );
  }
}

const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  #modal {
    background: #f3e29f;
  }
`;

export default ModelParayNagarawa;
